import React from 'react';
import { FormControlLabel, MenuItem, Select, OutlinedInput } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { DEFAULT_FONT, fontWeights, fonts } from '../../../../../../../../../../constants/playerConfigurationsConstant';
import CustomSlider from '../../../../../../../../../../reusable/Slider/CustomSlider';
import { useCustomStyles } from '../../../../../utils';

import './TextStyling.scss';

const SLIDER_OPTION_MARKS = [
	{ value: 0, label: '0' },
	{ value: 15 },
	{ value: 30 },
	{ value: 45 },
	{ value: 60 },
	{ value: 75 },
	{ value: 90 },
	{ value: 105 },
	{ value: 120 },
	{ value: 135 },
	{ value: 150, label: '1.5' },
];

interface TextStylingProps {
	id: string;
	font?: string;
	fontSize?: string;
	fontWeight?: string;
	lineHeight?: string;
	handleStylingAttributeChange: (_objKey: string | null, _attrKey: string, _value: any) => {};
}

const TextStyling = ({
	id,
	font,
	fontSize,
	fontWeight,
	lineHeight,
	handleStylingAttributeChange,
}: TextStylingProps) => {
	const { t: translator } = useTranslation();
	const classes = useCustomStyles();

	return (
		<>
		<FormControlLabel
			className={'scenario-chart__control'}
			label={translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_SETTING_FONT_FAMILY')}
			onChange={({ target }) => {
				handleStylingAttributeChange(`${id}Label`, 'font', (target as HTMLInputElement).value);
			}}
			labelPlacement="start"
			control={
				<Select variant="outlined" value={font} className={classes.input}>
					{fonts.map((fontOption) => (
						<MenuItem value={fontOption} key={fontOption}>
							{fontOption === DEFAULT_FONT ? translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_SETTING_FONT_FAMILY_DEFAULT') : fontOption}
						</MenuItem>
					))}
				</Select>
			}
		/>
		<FormControlLabel
			className={'scenario-chart__control'}
			label={translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_SETTING_FONT_SIZE')}
			onChange={({ target }) => {
				handleStylingAttributeChange(`${id}Label`, 'fontSize', (target as HTMLInputElement).value);
			}}
			labelPlacement="start"
			control={<OutlinedInput type="number" value={fontSize} className={classes.input} />}
		/>
		<FormControlLabel
			className={'scenario-chart__control'}
			label={translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_SETTING_FONT_WEIGHT')}
			onChange={({ target }) => {
				handleStylingAttributeChange(`${id}Label`, 'fontWeight', (target as HTMLInputElement).value);
			}}
			labelPlacement="start"
			control={
				<Select variant="outlined" value={fontWeight} className={classes.input}>
					{fontWeights.map((weight) => (
						<MenuItem value={weight} key={weight}>
							{weight}
						</MenuItem>
					))}
				</Select>
			}
		/>
		<FormControlLabel
			className={'scenario-chart__control'}
			label={translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_TEXT_WIDGET_STYLING_LINE_HEIGHT')}
			labelPlacement="start"
			control={
				<CustomSlider
					value={lineHeight}
					min={0}
					max={150}
					marks={SLIDER_OPTION_MARKS}
					onChange={(e: any, value: number | number[]) => {
						handleStylingAttributeChange(`${id}Label`, 'lineHeight', value);
					}}
				/>
			}
		/>
	</>
	);
};

export default TextStyling;
